import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import './App.css';
import Home from './user/Home';
import AdminLogin from './admin/AdminLogin';
import Dashboard from './admin/Dashboard';
import Program from './admin/Program';
import Bmi from './user/Bmi';
import Calorie from './user/Calorie';
import ProteinCalculator from './user/ProteinCalculator';
import About from './user/About';
import Programs from './user/Programs';
import ProgramDetails from './user/ProgramDetails';
import Contact from './user/Contact';
import Enquiries from './admin/Enquiries';
import Page404 from './Page404';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='*' element={<Page404 />}></Route>
          <Route path='/' element={<Home />}></Route>
          <Route path='/user/Bmi' element={<Bmi />}></Route>
          <Route path='/user/About' element={<About />}></Route>
          <Route path='/user/Calorie' element={<Calorie />}></Route>
          <Route path='/user/ProteinCalculator' element={<ProteinCalculator />}></Route>
          <Route path='/user/Programs' element={<Programs />}></Route>
          <Route path='/user/ProgramDetails' element={<ProgramDetails />}></Route>
          <Route path='/user/Contact' element={<Contact />}></Route>
          <Route path='/admin/' element={<AdminLogin />}></Route>
          <Route path='/admin/Dashboard' element={<Dashboard />}></Route>
          <Route path='/admin/Program' element={<Program />}></Route>
          <Route path='/admin/Enquiries' element={<Enquiries />}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
